// Therapist registration

import { createApp } from 'vue/dist/vue.esm-bundler'
import RegistrationModal from '@/components/zpmv/registration-modal/RegistrationModal.vue';

const RegistrationModalWrapper = document.querySelector('#ZpmvRegistrationModal');

if ( RegistrationModalWrapper )
{
  createApp({
    components: {
      RegistrationModal
    }
  }).mount('#ZpmvRegistrationModal');
}